// import React, { useEffect, useState } from 'react';
// import { Container, Card, Table, Button, Modal, Form, Row, Col } from 'react-bootstrap';
// import axios from 'axios';
// import { BsEye } from 'react-icons/bs';

// const Report = () => {
//   const [reports, setReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');

//   // Fetch all reports on initial load
//   useEffect(() => {
//     fetchReports();
//   }, []);

//   const fetchReports = async (sDate, eDate) => {
//     try {
//       let url = 'http://localhost:4001/reports';
//       if (sDate && eDate) {
//         url += `?startDate=${sDate}&endDate=${eDate}`;
//       }
//       const response = await axios.get(url);
//       setReports(response.data);
//     } catch (error) {
//       console.error('Error fetching reports:', error);
//     }
//   };

//   const handleViewReport = (report) => {
//     setSelectedReport(report);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedReport(null);
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     // Only call fetchReports if both dates are provided
//     if (startDate && endDate) {
//       fetchReports(startDate, endDate);
//     } else {
//       fetchReports();
//     }
//   };

//   const handleReset = () => {
//     setStartDate('');
//     setEndDate('');
//     fetchReports();
//   };

//   // Compute summary totals from reports data
//   const grandTotalCommission = reports.reduce((acc, report) => acc + report.commissionAmount, 0);
//   const grandTotalTransaction = reports.reduce((acc, report) => acc + report.totalAmount, 0);

//   return (
//     <Container className="my-4">
//       {/* Summary Section */}
//       <Card className="mb-4">
//         <Card.Header className="bg-info text-white">
//           <h5>Summary</h5>
//         </Card.Header>
//         <Card.Body>
//           <Row>
//             <Col md={6}>
//               <Card className="mb-3">
//                 <Card.Body>
//                   <Card.Title>Total Commission Amount</Card.Title>
//                   <Card.Text>{grandTotalCommission.toFixed(2)}৳</Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>
//             <Col md={6}>
//               <Card className="mb-3">
//                 <Card.Body>
//                   <Card.Title>Total Transaction Amount</Card.Title>
//                   <Card.Text>{grandTotalTransaction.toFixed(2)}৳</Card.Text>
//                 </Card.Body>
//               </Card>
//             </Col>
//           </Row>
//         </Card.Body>
//       </Card>

//       {/* Date Filter and Detailed List */}
//       <Card>
//         <Card.Header className="bg-primary text-white">
//           <h4>Transaction Reports</h4>
//         </Card.Header>
//         <Card.Body>
//           {/* Date Filter Form */}
//           <Form onSubmit={handleSearch} className="mb-3">
//             <Row className="align-items-end">
//               <Col md={4}>
//                 <Form.Group controlId="startDate">
//                   <Form.Label>Start Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4}>
//                 <Form.Group controlId="endDate">
//                   <Form.Label>End Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4}>
//                 <Button variant="primary" type="submit" className="me-2">
//                   Search
//                 </Button>
//                 <Button variant="secondary" onClick={handleReset}>
//                   Reset
//                 </Button>
//               </Col>
//             </Row>
//           </Form>

//           {/* Detailed Transactions Table */}
//           <Table responsive striped hover>
//             <thead>
//               <tr>
//                 <th>Order Number</th>
//                 <th>Service Name</th>
//                 <th>User Name</th>
//                 <th>Servitor Name</th>
//                 <th>Total Amount</th>
//                 <th>Commission Amount</th>
//                 <th>Transaction Date</th>
//                 <th>Action</th>
//               </tr>
//             </thead>
//             <tbody>
//               {reports.length > 0 ? (
//                 reports.map((report) => (
//                   <tr key={report.Id}>
//                     <td>{report.order_number}</td>
//                     <td>{report.Service?.services_name || 'N/A'}</td>
//                     <td>
//                       {report.User
//                         ? `${report.User.FirstName} ${report.User.LastName}`
//                         : 'N/A'}
//                     </td>
//                     <td>
//                       {report.Servitor
//                         ? `${report.Servitor.FirstName} ${report.Servitor.LastName}`
//                         : 'N/A'}
//                     </td>
//                     <td>{report.totalAmount.toFixed(2)}৳</td>
//                     <td>{report.commissionAmount.toFixed(2)}৳</td>
//                     <td>{new Date(report.transactionDate).toLocaleDateString()}</td>
//                     <td>
//                       <Button variant="outline-primary" onClick={() => handleViewReport(report)}>
//                         <BsEye />
//                       </Button>
//                     </td>
//                   </tr>
//                 ))
//               ) : (
//                 <tr>
//                   <td colSpan="8" className="text-center">
//                     No transactions found
//                   </td>
//                 </tr>
//               )}
//             </tbody>
//           </Table>
//         </Card.Body>
//       </Card>

//       {/* Modal for Viewing Report Details */}
//       {selectedReport && (
//         <Modal show={showModal} onHide={handleCloseModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Transaction Details</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <p>
//               <strong>Order Number:</strong> {selectedReport.order_number}
//             </p>
//             <p>
//               <strong>Service Name:</strong>{' '}
//               {selectedReport.Service?.services_name || 'N/A'}
//             </p>
//             <p>
//               <strong>User Name:</strong>{' '}
//               {selectedReport.User
//                 ? `${selectedReport.User.FirstName} ${selectedReport.User.LastName}`
//                 : 'N/A'}
//             </p>
//             <p>
//               <strong>Servitor Name:</strong>{' '}
//               {selectedReport.Servitor
//                 ? `${selectedReport.Servitor.FirstName} ${selectedReport.Servitor.LastName}`
//                 : 'N/A'}
//             </p>
//             <p>
//               <strong>Total Amount:</strong> {selectedReport.totalAmount.toFixed(2)}৳
//             </p>
//             <p>
//               <strong>Commission Amount:</strong> {selectedReport.commissionAmount.toFixed(2)}৳
//             </p>
//             <p>
//               <strong>Transaction Date:</strong>{' '}
//               {new Date(selectedReport.transactionDate).toLocaleString()}
//             </p>
//             {selectedReport.feedback && (
//               <p>
//                 <strong>Feedback:</strong> {selectedReport.feedback}
//               </p>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={handleCloseModal}>
//               Close
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       )}
//     </Container>
//   );
// };

// export default Report;





// import React, { useEffect, useState } from 'react';
// import { Container, Row, Col, Card, Table, Button, Modal, Form } from 'react-bootstrap';
// import axios from 'axios';
// import { BsEye } from 'react-icons/bs';

// const Report = () => {
//   const [reports, setReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [startDate, setStartDate] = useState('');
//   const [endDate, setEndDate] = useState('');

//   // Fetch all reports on initial load
//   useEffect(() => {
//     fetchReports();
//   }, []);

//   const fetchReports = async (sDate, eDate) => {
//     try {
//       let url = 'http://localhost:4001/reports';
//       if (sDate && eDate) {
//         url += `?startDate=${sDate}&endDate=${eDate}`;
//       }
//       const response = await axios.get(url);
//       setReports(response.data);
//     } catch (error) {
//       console.error('Error fetching reports:', error);
//     }
//   };

//   const handleViewReport = (report) => {
//     setSelectedReport(report);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedReport(null);
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (startDate && endDate) {
//       fetchReports(startDate, endDate);
//     } else {
//       fetchReports();
//     }
//   };

//   const handleReset = () => {
//     setStartDate('');
//     setEndDate('');
//     fetchReports();
//   };

//   // Compute summary totals from reports data
//   const grandTotalCommission = reports.reduce((acc, report) => acc + report.commissionAmount, 0);
//   const grandTotalTransaction = reports.reduce((acc, report) => acc + report.totalAmount, 0);

//   // Count of transactions for the filtered range
//   const totalResults = reports.length;

//   return (
//     <Container>
//       {/* Top Heading */}
//       <h3 className="mb-4">Transaction Dashboard</h3>

//       {/* Summary Row (Three Cards) */}
//       <Row className="mb-2">
//         {/* 1) Total Transaction Amount */}
//         <Col md={4} className="mb-3">
//           <Card
//             className="h-100 text-white"
//             style={{
//               background: 'linear-gradient(to right, #007bff, #02a499)',
//               border: 'none',
//             }}
//           >
//             <Card.Body>
//               <Card.Title style={{ fontSize: '1.2rem' }}>Total Transaction Amount</Card.Title>
//               <Card.Text style={{ fontSize: '2rem', fontWeight: 'bold' }}>
//                 {grandTotalTransaction.toFixed(2)}৳
//               </Card.Text>
//               <small>All transactions from today</small>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* 2) Total Commission Amount */}
//         <Col md={4} className="mb-3">
//           <Card
//             className="h-100 text-white"
//             style={{
//               background: 'linear-gradient(to right, #00c292, #02a499)',
//               border: 'none',
//             }}
//           >
//             <Card.Body>
//               <Card.Title style={{ fontSize: '1.2rem' }}>Total Commission Amount</Card.Title>
//               <Card.Text style={{ fontSize: '2rem', fontWeight: 'bold' }}>
//                 {grandTotalCommission.toFixed(2)}৳
//               </Card.Text>
//               <small>
//                 {((grandTotalCommission / (grandTotalTransaction || 1)) * 100).toFixed(2)}% of total transactions
//               </small>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* 3) Total Transaction Count */}
//         <Col md={4} className="mb-3">
//           <Card
//             className="h-100 text-white"
//             style={{
//               background: 'linear-gradient(to right, #6f42c1, #02a499)',
//               border: 'none',
//             }}
//           >
//             <Card.Body>
//               <Card.Title style={{ fontSize: '1.2rem' }}>Total Transaction Count</Card.Title>
//               <Card.Text style={{ fontSize: '2rem', fontWeight: 'bold' }}>
//                 {totalResults}
//               </Card.Text>
//               <small>All transactions from the selected range</small>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Transaction Reports */}
//       <Card>
//         <Card.Header className="bg-primary text-white">
//           <h5 className="mb-0">Transaction Reports</h5>
//         </Card.Header>
//         <Card.Body>
//           {/* Date Filter Form */}
//           <Form onSubmit={handleSearch} className="mb-4">
//             <Row className="align-items-end">
//               <Col md={4} className="mb-3">
//                 <Form.Group controlId="startDate">
//                   <Form.Label>Start Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     placeholder="mm/dd/yyyy"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-3">
//                 <Form.Group controlId="endDate">
//                   <Form.Label>End Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     placeholder="mm/dd/yyyy"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-3 d-flex">
//                 <div className="ms-auto">
//                   <Button variant="primary" type="submit" className="me-2">
//                     Search
//                   </Button>
//                   <Button variant="secondary" onClick={handleReset}>
//                     Reset
//                   </Button>
//                 </div>
//               </Col>
//             </Row>
//           </Form>

//           {/* Detailed Transactions Table */}
//           <div className="table-responsive">
//             <Table striped hover>
//               <thead className="table-light">
//                 <tr>
//                   <th>Order Number</th>
//                   <th>Service Name</th>
//                   <th>User Name</th>
//                   <th>Servitor Name</th>
//                   <th>Total Amount</th>
//                   <th>Commission Amount</th>
//                   <th>Transaction Date</th>
//                   <th style={{ width: '80px' }}>Action</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {reports.length > 0 ? (
//                   reports.map((report) => (
//                     <tr key={report.Id}>
//                       <td>{report.order_number}</td>
//                       <td>{report.Service?.services_name || 'N/A'}</td>
//                       <td>
//                         {report.User
//                           ? `${report.User.FirstName} ${report.User.LastName}`
//                           : 'N/A'}
//                       </td>
//                       <td>
//                         {report.Servitor
//                           ? `${report.Servitor.FirstName} ${report.Servitor.LastName}`
//                           : 'N/A'}
//                       </td>
//                       <td>{report.totalAmount.toFixed(2)}৳</td>
//                       <td>{report.commissionAmount.toFixed(2)}৳</td>
//                       <td>{new Date(report.transactionDate).toLocaleDateString()}</td>
//                       <td>
//                         <Button
//                           variant="outline-primary"
//                           size="sm"
//                           onClick={() => handleViewReport(report)}
//                         >
//                           <BsEye />
//                         </Button>
//                       </td>
//                     </tr>
//                   ))
//                 ) : (
//                   <tr>
//                     <td colSpan="8" className="text-center">
//                       No transactions found
//                     </td>
//                   </tr>
//                 )}
//               </tbody>
//             </Table>
//           </div>
//           {/* Results count */}
//           <div className="mt-2 text-muted" style={{ fontSize: '0.9rem' }}>
//             Showing 1 to {totalResults} results
//           </div>
//         </Card.Body>
//       </Card>

//       {/* Modal for Viewing Report Details */}
//       {selectedReport && (
//         <Modal show={showModal} onHide={handleCloseModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Transaction Details</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <p>
//               <strong>Order Number:</strong> {selectedReport.order_number}
//             </p>
//             <p>
//               <strong>Service Name:</strong> {selectedReport.Service?.services_name || 'N/A'}
//             </p>
//             <p>
//               <strong>User Name:</strong>{' '}
//               {selectedReport.User
//                 ? `${selectedReport.User.FirstName} ${selectedReport.User.LastName}`
//                 : 'N/A'}
//             </p>
//             <p>
//               <strong>Servitor Name:</strong>{' '}
//               {selectedReport.Servitor
//                 ? `${selectedReport.Servitor.FirstName} ${selectedReport.Servitor.LastName}`
//                 : 'N/A'}
//             </p>
//             <p>
//               <strong>Total Amount:</strong> {selectedReport.totalAmount.toFixed(2)}৳
//             </p>
//             <p>
//               <strong>Commission Amount:</strong> {selectedReport.commissionAmount.toFixed(2)}৳
//             </p>
//             <p>
//               <strong>Transaction Date:</strong>{' '}
//               {new Date(selectedReport.transactionDate).toLocaleString()}
//             </p>
//             {selectedReport.feedback && (
//               <p>
//                 <strong>Feedback:</strong> {selectedReport.feedback}
//               </p>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={handleCloseModal}>
//               Close
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       )}
//     </Container>
//   );
// };

// export default Report;




// import React, { useEffect, useState } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Table,
//   Button,
//   Modal,
//   Form,
//   Pagination,
// } from "react-bootstrap";
// import axios from "axios";
// import { BsEye } from "react-icons/bs";

// // Recharts imports
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
// } from "recharts";

// const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#845EC2"];

// const Report = () => {
//   const [reports, setReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState(null);
//   const [showModal, setShowModal] = useState(false);

//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");

//   // View mode: 'table' or 'graph'
//   const [viewMode, setViewMode] = useState("table");

//   // Pagination states
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10; // Adjust as needed

//   // Fetch all reports on initial load
//   useEffect(() => {
//     fetchReports();
//   }, []);

//   const fetchReports = async (sDate, eDate) => {
//     try {
//       let url = "http://localhost:4001/reports";
//       if (sDate && eDate) {
//         url += `?startDate=${sDate}&endDate=${eDate}`;
//       }
//       const response = await axios.get(url);
//       setReports(response.data);
//       setCurrentPage(1); // Reset to page 1 whenever new data is fetched
//     } catch (error) {
//       console.error("Error fetching reports:", error);
//     }
//   };

//   const handleViewReport = (report) => {
//     setSelectedReport(report);
//     setShowModal(true);
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedReport(null);
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (startDate && endDate) {
//       fetchReports(startDate, endDate);
//     } else {
//       fetchReports();
//     }
//   };

//   const handleReset = () => {
//     setStartDate("");
//     setEndDate("");
//     fetchReports();
//   };

//   // --- SUMMARY CALCULATIONS ---
//   const grandTotalCommission = reports.reduce(
//     (acc, report) => acc + report.commissionAmount,
//     0
//   );
//   const grandTotalTransaction = reports.reduce(
//     (acc, report) => acc + report.totalAmount,
//     0
//   );
//   const totalResults = reports.length;

//   // --- PAGINATION LOGIC ---
//   const totalPages = Math.ceil(totalResults / itemsPerPage);
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   // Slice the reports array for the current page
//   const currentItems = reports.slice(indexOfFirstItem, indexOfLastItem);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   // --- AGGREGATE DATA FOR CHARTS ---
//   // We'll create an object with serviceName -> { revenue, count, commission }
//   const serviceStats = {};
//   reports.forEach((report) => {
//     const serviceName = report.Service?.services_name || "Unknown";
//     if (!serviceStats[serviceName]) {
//       serviceStats[serviceName] = { revenue: 0, count: 0, commission: 0 };
//     }
//     serviceStats[serviceName].revenue += report.totalAmount;
//     serviceStats[serviceName].count += 1;
//     serviceStats[serviceName].commission += report.commissionAmount;
//   });

//   // Convert object to array for Recharts
//   const chartData = Object.keys(serviceStats).map((service) => ({
//     service,
//     revenue: serviceStats[service].revenue,
//     count: serviceStats[service].count,
//     commission: serviceStats[service].commission,
//   }));

//   // Prepare data for Pie chart (revenue distribution)
//   // Example: each slice is { name: service, value: revenue }
//   const pieData = chartData.map((item) => ({
//     name: item.service,
//     value: item.revenue,
//   }));

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     const day = date.getDate().toString().padStart(2, '0');
//     const month = (date.getMonth() + 1).toString().padStart(2, '0');
//     const year = date.getFullYear();
//     return `${day}/${month}/${year}`;
//   };
  

//   return (
//     <Container fluid>
//       {/* Top Heading */}
//       <h3 className="mt-2 mb-4">Transaction Dashboard</h3>

//       {/* Summary Row (Three Cards) */}
//       <Row className="mb-2">
//         {/* 1) Total Transaction Amount */}
//         <Col md={4} className="mb-3">
//           <Card
//             className="h-100 text-white"
//             style={{
//               background: "linear-gradient(to right, #007bff, #02a499)",
//               border: "none",
//             }}
//           >
//             <Card.Body>
//               <Card.Title style={{ fontSize: "1.2rem" }}>
//                 Total Transaction Amount
//               </Card.Title>
//               <Card.Text style={{ fontSize: "2rem", fontWeight: "bold" }}>
//                 {grandTotalTransaction.toFixed(2)}৳
//               </Card.Text>
//               <small>All transactions from the selected range</small>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* 2) Total Commission Amount */}
//         <Col md={4} className="mb-3">
//           <Card
//             className="h-100 text-white"
//             style={{
//               background: "linear-gradient(to right, #00c292, #02a499)",
//               border: "none",
//             }}
//           >
//             <Card.Body>
//               <Card.Title style={{ fontSize: "1.2rem" }}>
//                 Total Commission Amount
//               </Card.Title>
//               <Card.Text style={{ fontSize: "2rem", fontWeight: "bold" }}>
//                 {grandTotalCommission.toFixed(2)}৳
//               </Card.Text>
//               <small>
//                 {(
//                   (grandTotalCommission / (grandTotalTransaction || 1)) *
//                   100
//                 ).toFixed(2)}
//                 % of total transactions
//               </small>
//             </Card.Body>
//           </Card>
//         </Col>

//         {/* 3) Total Transaction Count */}
//         <Col md={4} className="mb-3">
//           <Card
//             className="h-100 text-white"
//             style={{
//               background: "linear-gradient(to right, #6f42c1, #02a499)",
//               border: "none",
//             }}
//           >
//             <Card.Body>
//               <Card.Title style={{ fontSize: "1.2rem" }}>
//                 Total Transaction Count
//               </Card.Title>
//               <Card.Text style={{ fontSize: "2rem", fontWeight: "bold" }}>
//                 {totalResults}
//               </Card.Text>
//               <small>Transactions from the selected range</small>
//             </Card.Body>
//           </Card>
//         </Col>
//       </Row>

//       {/* Transaction Reports */}
//       <Card>
//         <Card.Header className="bg-primary text-white d-flex justify-content-between align-items-center">
//           <h5 className="mb-0">Transaction Reports</h5>
//           {/* View Mode Toggle Buttons */}
//           <div>
//             <Button
//               variant={viewMode === "table" ? "light" : "outline-light"}
//               className="me-2"
//               onClick={() => setViewMode("table")}
//             >
//               Table View
//             </Button>
//             <Button
//               variant={viewMode === "graph" ? "light" : "outline-light"}
//               onClick={() => setViewMode("graph")}
//             >
//               Graph View
//             </Button>
//           </div>
//         </Card.Header>
//         <Card.Body>
//           {/* Date Filter Form */}
//           <Form onSubmit={handleSearch} className="mb-4">
//             <Row className="align-items-end">
//               <Col md={4} className="mb-3">
//                 <Form.Group controlId="startDate">
//                   <Form.Label>Start Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     placeholder="mm/dd/yyyy"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-3">
//                 <Form.Group controlId="endDate">
//                   <Form.Label>End Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     placeholder="mm/dd/yyyy"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-3 d-flex">
//                 <div className="ms-auto">
//                   <Button variant="primary" type="submit" className="me-2">
//                     Search
//                   </Button>
//                   <Button variant="secondary" onClick={handleReset}>
//                     Reset
//                   </Button>
//                 </div>
//               </Col>
//             </Row>
//           </Form>

//           {/* Conditional Rendering: Table View vs Graph View */}
//           {viewMode === "table" ? (
//             // --- TABLE VIEW ---
//             <>
//               <div className="table-responsive">
//                 <Table striped hover>
//                   <thead className="table-light">
//                     <tr>
//                       <th>Order Number</th>
//                       <th>Service Name</th>
//                       <th>User Name</th>
//                       <th>Servitor Name</th>
//                       <th>Total Amount</th>
//                       <th>Commission Amount</th>
//                       <th>Transaction Date</th>
//                       <th style={{ width: "80px" }}>Action</th>
//                     </tr>
//                   </thead>
//                   <tbody>
//                     {currentItems.length > 0 ? (
//                       currentItems.map((report) => (
//                         <tr key={report.Id}>
//                           <td>{report.order_number}</td>
//                           <td>{report.Service?.services_name || "N/A"}</td>
//                           <td>
//                             {report.User
//                               ? `${report.User.FirstName} ${report.User.LastName}`
//                               : "N/A"}
//                           </td>
//                           <td>
//                             {report.Servitor
//                               ? `${report.Servitor.FirstName} ${report.Servitor.LastName}`
//                               : "N/A"}
//                           </td>
//                           <td>{report.totalAmount.toFixed(2)}৳</td>
//                           <td>{report.commissionAmount.toFixed(2)}৳</td>
//                           <td>
//                             {/* {new Date(report.transactionDate).toLocaleDateString()} */}
//                             {formatDate(report.transactionDate)}
//                           </td>
//                           <td>
//                             <Button
//                               variant="outline-primary"
//                               size="sm"
//                               onClick={() => handleViewReport(report)}
//                             >
//                               <BsEye />
//                             </Button>
//                           </td>
//                         </tr>
//                       ))
//                     ) : (
//                       <tr>
//                         <td colSpan="8" className="text-center">
//                           No transactions found
//                         </td>
//                       </tr>
//                     )}
//                   </tbody>
//                 </Table>
//               </div>

//               {/* Pagination */}
//               {totalPages > 1 && (
//                 <Pagination className="mt-2">
//                   <Pagination.First
//                     onClick={() => handlePageChange(1)}
//                     disabled={currentPage === 1}
//                   />
//                   <Pagination.Prev
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   />
//                   {[...Array(totalPages)].map((_, index) => (
//                     <Pagination.Item
//                       key={index + 1}
//                       active={index + 1 === currentPage}
//                       onClick={() => handlePageChange(index + 1)}
//                     >
//                       {index + 1}
//                     </Pagination.Item>
//                   ))}
//                   <Pagination.Next
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   />
//                   <Pagination.Last
//                     onClick={() => handlePageChange(totalPages)}
//                     disabled={currentPage === totalPages}
//                   />
//                 </Pagination>
//               )}

//               {/* Results count */}
//               <div className="mt-2 text-muted" style={{ fontSize: "0.9rem" }}>
//                 Showing {indexOfFirstItem + 1} to{" "}
//                 {Math.min(indexOfLastItem, totalResults)} of {totalResults} results
//               </div>
//             </>
//           ) : (
//             // --- GRAPH VIEW ---
//             <>
//               <Row>
//                 <Row>
//                   {/* Revenue by Service Type */}
//                   <Col md={6} className="mb-4">
//                     <Card className="shadow-sm">
//                       <Card.Body>
//                         <h5 className="mb-3">Revenue by Service Type</h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <BarChart data={chartData}>
//                               <XAxis dataKey="service" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar
//                                 dataKey="revenue"
//                                 fill="#8884d8"
//                                 name="Revenue"
//                               />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>

//                   {/* Commission by Service Type */}
//                   <Col md={6} className="mb-4">
//                     <Card className="shadow-sm">
//                       <Card.Body>
//                         <h5 className="mb-3">Commission by Service Type</h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <BarChart data={chartData}>
//                               <XAxis dataKey="service" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar
//                                 dataKey="commission"
//                                 fill="#ffc658"
//                                 name="Commission"
//                               />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                 </Row>

//                 <Row>
//                   {/* Transaction Count by Service Type */}
//                   <Col md={6} className="mb-4">
//                     <Card className="shadow-sm">
//                       <Card.Body>
//                         <h5 className="mb-3">
//                           Transaction Count by Service Type
//                         </h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <BarChart data={chartData}>
//                               <XAxis dataKey="service" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar
//                                 dataKey="count"
//                                 fill="#82ca9d"
//                                 name="Transaction Count"
//                               />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>

//                   {/* Revenue Distribution (Pie Chart) */}
//                   <Col md={6}>
//                     <Card className="shadow-sm">
//                       <Card.Body>
//                         <h5 className="mb-3">Revenue Distribution</h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <PieChart>
//                               <Pie
//                                 data={pieData}
//                                 dataKey="value"
//                                 nameKey="name"
//                                 outerRadius={100}
//                                 label
//                               >
//                                 {pieData.map((entry, index) => (
//                                   <Cell
//                                     key={`cell-${index}`}
//                                     fill={COLORS[index % COLORS.length]}
//                                   />
//                                 ))}
//                               </Pie>
//                               <Tooltip />
//                             </PieChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                 </Row>
//               </Row>
//             </>
//           )}
//         </Card.Body>
//       </Card>

//       {/* Modal for Viewing Report Details */}
//       {selectedReport && (
//         <Modal show={showModal} onHide={handleCloseModal} centered>
//           <Modal.Header closeButton>
//             <Modal.Title>Transaction Details</Modal.Title>
//           </Modal.Header>
//           <Modal.Body>
//             <p>
//               <strong>Order Number:</strong> {selectedReport.order_number}
//             </p>
//             <p>
//               <strong>Service Name:</strong>{" "}
//               {selectedReport.Service?.services_name || "N/A"}
//             </p>
//             <p>
//               <strong>User Name:</strong>{" "}
//               {selectedReport.User
//                 ? `${selectedReport.User.FirstName} ${selectedReport.User.LastName}`
//                 : "N/A"}
//             </p>
//             <p>
//               <strong>Servitor Name:</strong>{" "}
//               {selectedReport.Servitor
//                 ? `${selectedReport.Servitor.FirstName} ${selectedReport.Servitor.LastName}`
//                 : "N/A"}
//             </p>
//             <p>
//               <strong>Total Amount:</strong>{" "}
//               {selectedReport.totalAmount.toFixed(2)}৳
//             </p>
//             <p>
//               <strong>Commission Amount:</strong>{" "}
//               {selectedReport.commissionAmount.toFixed(2)}৳
//             </p>
//             <p>
//               <strong>Transaction Date:</strong>{" "}
//               {new Date(selectedReport.transactionDate).toLocaleString()}
//             </p>
//             {selectedReport.feedback && (
//               <p>
//                 <strong>Feedback:</strong> {selectedReport.feedback}
//               </p>
//             )}
//           </Modal.Body>
//           <Modal.Footer>
//             <Button variant="secondary" onClick={handleCloseModal}>
//               Close
//             </Button>
//           </Modal.Footer>
//         </Modal>
//       )}
//     </Container>
//   );
// };

// export default Report;









// import React, { useEffect, useState, useRef, useCallback } from "react";
// import {
//   Container,
//   Row,
//   Col,
//   Card,
//   Table,
//   Button,
//   Form,
//   Pagination,
//   Spinner,
//   Alert,
// } from "react-bootstrap";
// import axios from "axios";
// import { BsEye } from "react-icons/bs";
// import {
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
//   ResponsiveContainer,
// } from "recharts";
// import { FaTimes } from "react-icons/fa";
// import "./Report.css";
// import { URL } from "../../../config";

// const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#845EC2"];

// const Report = () => {
//   const [reports, setReports] = useState([]);
//   const [filteredReports, setFilteredReports] = useState([]);
//   const [selectedReport, setSelectedReport] = useState(null);
//   const [showModal, setShowModal] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [startDate, setStartDate] = useState("");
//   const [endDate, setEndDate] = useState("");
//   const [viewMode, setViewMode] = useState("table");
//   const [currentPage, setCurrentPage] = useState(1);
//   const itemsPerPage = 10;
//   const modalRef = useRef();
//   const token = localStorage.getItem("adminToken");

  
//   const fetchReports = useCallback(async (sDate, eDate) => {
//     setLoading(true);
//     try {
//       let url = `${URL}/reports`;
//       if (sDate && eDate) {
//         url += `?startDate=${sDate}&endDate=${eDate}`;
//       }
//       const response = await axios.get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setReports(response.data);
//       setFilteredReports(response.data);
//       setCurrentPage(1);
//       setError("");
//     } catch (error) {
//       setError("Failed to load reports. Please try again.");
//       console.error("Error fetching reports:", error);
//     } finally {
//       setLoading(false);
//     }
//   }, [token]);


//   useEffect(() => {
//     fetchReports();
//   }, [fetchReports]);


//   useEffect(() => {
//     let results = reports;
//     if (startDate && endDate) {
//       results = results.filter((report) => {
//         const transactionDate = new Date(report.transactionDate).toISOString().split("T")[0];
//         return transactionDate >= startDate && transactionDate <= endDate;
//       });
//     }
//     setFilteredReports(results);
//     setCurrentPage(1);
//   }, [startDate, endDate, reports]);

//   const handleViewReport = (report) => {
//     setSelectedReport(report);
//     setShowModal(true);
//     document.body.style.overflow = "hidden";
//   };

//   const handleCloseModal = () => {
//     setShowModal(false);
//     setSelectedReport(null);
//     document.body.style.overflow = "auto";
//   };

//   useEffect(() => {
//     const node = modalRef.current;
//     const handleBackdropClick = (e) => {
//       if (node && e.target === node) handleCloseModal();
//     };
//     const handleEscapeKey = (e) => {
//       if (e.key === "Escape") handleCloseModal();
//     };
//     if (node) node.addEventListener("click", handleBackdropClick);
//     document.addEventListener("keydown", handleEscapeKey);
//     return () => {
//       if (node) node.removeEventListener("click", handleBackdropClick);
//       document.removeEventListener("keydown", handleEscapeKey);
//     };
//   }, []);

//   const handleSearch = (e) => {
//     e.preventDefault();
//     if (startDate && endDate) {
//       fetchReports(startDate, endDate);
//     } else {
//       fetchReports();
//     }
//   };

//   const handleReset = () => {
//     setStartDate("");
//     setEndDate("");
//     fetchReports();
//   };

//   // Summary Calculations
//   const grandTotalCommission = filteredReports.reduce(
//     (acc, report) => acc + report.commissionAmount,
//     0
//   );
//   const grandTotalTransaction = filteredReports.reduce(
//     (acc, report) => acc + report.totalAmount,
//     0
//   );

//   const grandTotalBonus = filteredReports.reduce(
//   (acc, report) => acc + (report.servitorBonus || 0),
//   0
// );

//   const totalResults = filteredReports.length;

//   // Pagination Logic
//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filteredReports.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filteredReports.length / itemsPerPage);

//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//   };

//   const getPageItems = (total, current, maxButtons = 7) => {
//     const pages = [];
//     pages.push(1);
//     const siblings = Math.floor((maxButtons - 3) / 2);
//     let start = Math.max(2, current - siblings);
//     let end = Math.min(total - 1, current + siblings);
//     if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
//     if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
//     if (start > 2) pages.push("start-ellipsis");
//     for (let i = start; i <= end; i++) pages.push(i);
//     if (end < total - 1) pages.push("end-ellipsis");
//     if (total > 1) pages.push(total);
//     return pages;
//   };

//   // Chart Data
//   const serviceStats = {};
//   filteredReports.forEach((report) => {
//     const serviceName = report.Service?.services_name || "Unknown";

//     const isBonusTxn = report.txnType === "reward_claim" || report.servitorBonus > 0;

//     // Skip bonus or unknown service entries for main revenue/commission charts
//     if (serviceName === "Unknown" || isBonusTxn) return;

//     if (!serviceStats[serviceName]) {
//       serviceStats[serviceName] = { revenue: 0, count: 0, commission: 0 };
//     }
//     serviceStats[serviceName].revenue += report.totalAmount;
//     serviceStats[serviceName].count += 1;
//     serviceStats[serviceName].commission += report.commissionAmount;
//   });

//   const chartData = Object.keys(serviceStats).map((service) => ({
//     service,
//     revenue: serviceStats[service].revenue,
//     count: serviceStats[service].count,
//     commission: serviceStats[service].commission,
//   }));

//   const pieData = chartData.map((item) => ({
//     name: item.service,
//     value: item.revenue,
//   }));

//   const formatDateTime = (iso) => {
//     const d = new Date(iso);
//     const dateStr = d.toLocaleDateString("en-US", {
//       day: "numeric",
//       month: "long",
//       year: "numeric",
//     });
//     const [month, day, year] = dateStr.replace(",", "").split(" ");
//     const datePart = `${day}-${month}-${year}`;
//     const timeStr = d
//       .toLocaleTimeString("en-US", {
//         hour: "numeric",
//         minute: "2-digit",
//         second: "2-digit",
//         hour12: true,
//       })
//       .toLowerCase();
//     return `${datePart}, ${timeStr}`;
//   };

//   const renderReportDetails = () => {
//     if (!selectedReport) return null;
//     const {
//       order_number,
//       Service,
//       User,
//       Servitor,
//       totalAmount,
//       commissionAmount,
//       netAmount,
//       transactionDate,
//       feedback,
//       rating,
//     } = selectedReport;

//     return (
//       <div className="adminReportdetails-modal">
//         <div className="adminReportdetails-modal-header">
//           <button
//             className="adminReportdetails-modal-close"
//             onClick={handleCloseModal}
//           >
//             <FaTimes size={20} />
//           </button>
//           <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
//             <div className="adminReportdetails-service-icon">
//               <i className="fas fa-tools" style={{ color: "#f59e0b" }} />
//             </div>
//             <div>
//               <h2 className="adminReportdetails-modal-title">
//                 Details of Order Number #{order_number}
//               </h2>
//               <p className="adminReportdetails-modal-subtitle">
//                 {Service?.services_name || "N/A"} • Transaction
//               </p>
//             </div>
//           </div>
//         </div>
//         <div className="adminReportdetails-modal-body">
//           {/* Summary Cards */}
//           <div className="adminReportdetails-summary-cards">
//             <div className="adminReportdetails-summary-card adminReportdetails-amount-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Total Amount</p>
//                 <p className="adminReportdetails-price-value">৳{totalAmount.toFixed(2)}</p>
//               </div>
//             </div>
//             <div className="adminReportdetails-summary-card adminReportdetails-commission-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Commission</p>
//                 <p className="adminReportdetails-price-value">৳{commissionAmount.toFixed(2)}</p>
//               </div>
//             </div>
//             <div className="adminReportdetails-summary-card adminReportdetails-net-amount-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Net Amount</p>
//                 <p className="adminReportdetails-price-value">৳{netAmount.toFixed(2)}</p>
//               </div>
//             </div>
//             <div className="adminReportdetails-summary-card adminReportdetails-date-card">
//               <div>
//                 <p className="adminReportdetails-detail-text">Date & Time</p>
//                 <p className="adminReportdetails-detail-value">{formatDateTime(transactionDate)}</p>
//               </div>
//             </div>
//           </div>

//           {/* User Details */}
//           <div className="adminReportdetails-detail-card">
//             <h3 className="adminReportdetails-detail-title">
//               <i className="fas fa-user" style={{ marginRight: "8px", color: "#f59e0b" }} />
//               User Details
//             </h3>
//             <div className="adminReportdetails-detail-grid">
//               <div>
//                 <p className="adminReportdetails-detail-text">Name</p>
//                 <p className="adminReportdetails-detail-value">
//                   {User ? `${User.FirstName} ${User.LastName}` : "N/A"}
//                 </p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">User Id</p>
//                 <p className="adminReportdetails-detail-value">
//                   {User?.Id || "N/A"}
//                 </p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Mobile</p>
//                 <p className="adminReportdetails-detail-value">{User?.mobile || "N/A"}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Address</p>
//                 <p className="adminReportdetails-detail-value">{User?.Address || "N/A"}</p>
//               </div>
//             </div>
//           </div>

//           {/* Servitor Details */}
//           <div className="adminReportdetails-detail-card">
//             <h3 className="adminReportdetails-detail-title">
//               <i className="fas fa-user-tie" style={{ marginRight: "8px", color: "#f59e0b" }} />
//               Servitor Details
//             </h3>
//             <div className="adminReportdetails-detail-grid">
//               <div>
//                 <p className="adminReportdetails-detail-text">Name</p>
//                 <p className="adminReportdetails-detail-value">
//                   {Servitor ? `${Servitor.FirstName} ${Servitor.LastName}` : "N/A"}
//                 </p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Servitor Id</p>
//                 <p className="adminReportdetails-detail-value">{Servitor?.Id || "N/A"}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Mobile</p>
//                 <p className="adminReportdetails-detail-value">{Servitor?.mobile || "N/A"}</p>
//               </div>
//               <div>
//                 <p className="adminReportdetails-detail-text">Service</p>
//                 <p className="adminReportdetails-detail-value">{Service?.services_name || "N/A"}</p>
//               </div>
//             </div>
//           </div>

//           {/* Ratings and Feedback */}
//           <div className="adminReportdetails-detail-card">
//             <h3 className="adminReportdetails-detail-title">
//               <i className="fas fa-comment" style={{ marginRight: "8px", color: "#f59e0b" }} />
//               Ratings & Feedback
//             </h3>
//             <div className="adminReportdetails-feedback-list">
//               <div>
//                 <p className="adminReportdetails-detail-text">Rating</p>
//                 <p className="adminReportdetails-rating-value">
//                   {rating ? rating.toFixed(1) : "N/A"} / 5
//                 </p>
//                 <div className="adminReportdetails-star-container">
//                   {[...Array(5)].map((_, index) => (
//                     <i
//                       key={index}
//                       className="fas fa-star"
//                       style={{
//                         color: index < Math.round(rating || 0) ? "#f59e0b" : "#e5e7eb",
//                       }}
//                     />
//                   ))}
//                 </div>
//               </div>
//               <hr className="adminReportdetails-rating-underline" />
//               <div>
//                 <p className="adminReportdetails-detail-text">Feedback</p>
//                 {feedback ? (
//                   <div className="adminReportdetails-feedback-item">
//                     <p className="adminReportdetails-feedback-comment">{feedback}</p>
//                     <p className="adminReportdetails-feedback-date">{formatDateTime(transactionDate)}</p>
//                   </div>
//                 ) : (
//                   <p className="adminReportdetails-detail-value">No feedback available.</p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>
//         <div className="adminReportdetails-modal-footer">
//           <div className="adminReportdetails-footer-buttons">
//             <button
//               className="adminReportdetails-footer-btn adminReportdetails-footer-btn-close"
//               onClick={handleCloseModal}
//             >
//               <FaTimes /> Close
//             </button>
//           </div>
//         </div>
//       </div>
//     );
//   };

//   return (
//     <Container fluid className="adminReportdetails-container">
//       <Card className="adminReportdetails-card">
//         <Card.Header className="adminReportdetails-header">
//           <h4 className="adminReportdetails-title">Transaction Details</h4>
//         </Card.Header>
//         <Card.Body>
//           {/* Stats Cards */}
//           <div className="adminReportdetails-stats-container">
//             <div className="adminReportdetails-stats-card adminReportdetails-blue">
//               <div className="adminReportdetails-stats-icon">
//                 <i className="fas fa-money-bill-wave"></i>
//               </div>
//               <div className="adminReportdetails-stats-title">TOTAL TRANSACTION AMOUNT</div>
//               <div className="adminReportdetails-stats-value">{grandTotalTransaction.toFixed(2)}৳</div>
//             </div>
//             <div className="adminReportdetails-stats-card adminReportdetails-green">
//               <div className="adminReportdetails-stats-icon">
//                 <i className="fas fa-coins"></i>
//               </div>
//               <div className="adminReportdetails-stats-title">TOTAL COMMISSION</div>
//               <div className="adminReportdetails-stats-value">{grandTotalCommission.toFixed(2)}৳</div>
//             </div>

//             <div className="adminReportdetails-stats-card adminReportdetails-orange">
//               <div className="adminReportdetails-stats-icon">
//                 <i className="fas fa-gift"></i>
//               </div>
//               <div className="adminReportdetails-stats-title">TOTAL SERVITOR BONUS</div>
//               <div className="adminReportdetails-stats-value">{grandTotalBonus.toFixed(2)}৳</div>
//             </div>

//             <div className="adminReportdetails-stats-card adminReportdetails-purple">
//               <div className="adminReportdetails-stats-icon">
//                 <i className="fas fa-chart-bar"></i>
//               </div>
//               <div className="adminReportdetails-stats-title">TRANSACTION COUNT</div>
//               <div className="adminReportdetails-stats-value">{totalResults}</div>
//             </div>
//           </div>

//           {/* Date Filter Form */}
//           <Form onSubmit={handleSearch} className="mb-4">
//             <Row className="align-items-end">
//               <Col md={4} className="mb-3">
//                 <Form.Group controlId="startDate">
//                   <Form.Label>Start Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={startDate}
//                     onChange={(e) => setStartDate(e.target.value)}
//                     className="adminReportdetails-search"
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-3">
//                 <Form.Group controlId="endDate">
//                   <Form.Label>End Date</Form.Label>
//                   <Form.Control
//                     type="date"
//                     value={endDate}
//                     onChange={(e) => setEndDate(e.target.value)}
//                     className="adminReportdetails-search"
//                   />
//                 </Form.Group>
//               </Col>
//               <Col md={4} className="mb-3 d-flex">
//                 <div className="ms-auto">
//                   <Button variant="primary" type="submit" className="me-2 adminReportdetails-filter-btn">
//                     Search
//                   </Button>
//                   <Button
//                     variant="outline-primary"
//                     onClick={handleReset}
//                     className="adminReportdetails-filter-btn"
//                   >
//                     Reset
//                   </Button>
//                 </div>
//               </Col>
//             </Row>
//           </Form>

//           {/* View Toggle Buttons */}
//           <div className="adminReportdetails-filter-container">
//             <div className="adminReportdetails-service-filters">
//               <Button
//                 variant={viewMode === "table" ? "primary" : "outline-primary"}
//                 className="adminReportdetails-filter-btn"
//                 onClick={() => setViewMode("table")}
//               >
//                 Table View
//               </Button>
//               <Button
//                 variant={viewMode === "graph" ? "primary" : "outline-primary"}
//                 className="adminReportdetails-filter-btn"
//                 onClick={() => setViewMode("graph")}
//               >
//                 Graph View
//               </Button>
//             </div>
//           </div>

//           {loading && (
//             <div className="text-center">
//               <Spinner animation="border" />
//             </div>
//           )}
//           {error && (
//             <Alert variant="danger" className="adminReportdetails-error">
//               {error}
//             </Alert>
//           )}
//           {!loading && !error && filteredReports.length === 0 && (
//             <p className="adminReportdetails-empty-text">No transactions found.</p>
//           )}
//           {!loading && filteredReports.length > 0 && (
//             <>
//               {viewMode === "table" ? (
//                 <>
//                   <Table striped bordered hover responsive className="adminReportdetails-table">
//                     <thead>
//                       <tr>
//                         <th>#</th>
//                         <th>Order Number</th>
//                         <th>Service Name</th>
//                         {/* <th>User Name</th>
//                         <th>Servitor Name</th> */}
//                         <th>Total Amount</th>
//                         <th>Commission</th>
//                         <th>Servitor Bonus</th>
//                         <th>Transaction Date</th>
//                         <th>Actions</th>
//                       </tr>
//                     </thead>
//                     <tbody>
//                       {currentItems.map((report, index) => (
//                         <tr key={report.Id}>
//                           <td>{index + 1 + indexOfFirstItem}</td>
//                           <td>{report.order_number}</td>
//                           <td>{report.Service?.services_name || "N/A"}</td>
//                           {/* <td>
//                             {report.User
//                               ? `${report.User.FirstName} ${report.User.LastName}`
//                               : "N/A"}
//                           </td>
//                           <td>
//                             {report.Servitor
//                               ? `${report.Servitor.FirstName} ${report.Servitor.LastName}`
//                               : "N/A"}
//                           </td> */}
//                           <td>{report.totalAmount.toFixed(2)}৳</td>
//                           <td>{report.commissionAmount.toFixed(2)}৳</td>
//                           <td>{report.servitorBonus && report.servitorBonus > 0 ? `৳${report.servitorBonus.toFixed(2)}` : "-"}</td>
//                           <td>{formatDateTime(report.transactionDate)}</td>
//                           <td>
//                             <Button
//                               variant="outline-primary"
//                               size="sm"
//                               className="adminReportdetails-action-btn"
//                               onClick={() => handleViewReport(report)}
//                             >
//                               <BsEye size={16} />
//                             </Button>
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                   </Table>
//                   <Pagination>
//                     <Pagination.First
//                       onClick={() => handlePageChange(1)}
//                       disabled={currentPage === 1}
//                     />
//                     <Pagination.Prev
//                       onClick={() => handlePageChange(currentPage - 1)}
//                       disabled={currentPage === 1}
//                     />
//                     {getPageItems(totalPages, currentPage).map((item, idx) =>
//                       item === "start-ellipsis" || item === "end-ellipsis" ? (
//                         <Pagination.Ellipsis key={item + idx} disabled />
//                       ) : (
//                         <Pagination.Item
//                           key={item}
//                           active={item === currentPage}
//                           onClick={() => handlePageChange(item)}
//                         >
//                           {item}
//                         </Pagination.Item>
//                       )
//                     )}
//                     <Pagination.Next
//                       onClick={() => handlePageChange(currentPage + 1)}
//                       disabled={currentPage === totalPages}
//                     />
//                     <Pagination.Last
//                       onClick={() => handlePageChange(totalPages)}
//                       disabled={currentPage === totalPages}
//                     />
//                   </Pagination>
//                   <div className="mt-2 text-muted adminReportdetails-results-text">
//                     Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, totalResults)} of {totalResults} results
//                   </div>
//                 </>
//               ) : (
//                 <Row>
//                   <Col md={6} className="mb-4">
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Revenue by Service Type</h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <BarChart data={chartData}>
//                               <XAxis dataKey="service" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar dataKey="revenue" fill="#8884d8" name="Revenue" />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                   <Col md={6} className="mb-4">
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Commission by Service Type</h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <BarChart data={chartData}>
//                               <XAxis dataKey="service" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar dataKey="commission" fill="#ffc658" name="Commission" />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                   <Col md={6} className="mb-4">
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Transaction Count by Service Type</h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <BarChart data={chartData}>
//                               <XAxis dataKey="service" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar dataKey="count" fill="#82ca9d" name="Transaction Count" />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>
//                   <Col md={6}>
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Revenue Distribution</h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <PieChart>
//                               <Pie
//                                 data={pieData}
//                                 dataKey="value"
//                                 nameKey="name"
//                                 outerRadius={100}
//                                 label
//                               >
//                                 {pieData.map((entry, index) => (
//                                   <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
//                                 ))}
//                               </Pie>
//                               <Tooltip />
//                             </PieChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col>

//                   {/* <Col md={6}>
//                     <Card className="adminReportdetails-chart-card">
//                       <Card.Body>
//                         <h5 className="adminReportdetails-chart-title">Servitor Bonus Overview</h5>
//                         <div style={{ width: "100%", height: 300 }}>
//                           <ResponsiveContainer>
//                             <BarChart
//                               data={filteredReports
//                                 .filter(r => r.servitorBonus > 0)
//                                 .map((r) => ({
//                                   servitor: r.Servitor
//                                     ? `${r.Servitor.FirstName} ${r.Servitor.LastName}`
//                                     : "Unknown Servitor",
//                                   bonus: r.servitorBonus,
//                                 }))
//                                 .reduce((acc, item) => {
//                                   const existing = acc.find(a => a.servitor === item.servitor);
//                                   if (existing) existing.bonus += item.bonus;
//                                   else acc.push(item);
//                                   return acc;
//                                 }, [])}
//                             >
//                               <XAxis dataKey="servitor" />
//                               <YAxis />
//                               <Tooltip />
//                               <Legend />
//                               <Bar dataKey="bonus" fill="#FF8042" name="Bonus (৳)" />
//                             </BarChart>
//                           </ResponsiveContainer>
//                         </div>
//                       </Card.Body>
//                     </Card>
//                   </Col> */}

//                 </Row>
//               )}
//             </>
//           )}
//         </Card.Body>
//       </Card>
//       {showModal && (
//         <div className="adminReportdetails-modal-backdrop" ref={modalRef}>
//           {renderReportDetails()}
//         </div>
//       )}
//     </Container>
//   );
// };

// export default Report;











// ***** Update with backend paginations (20-Oct-2025) ***** //
import React, { useEffect, useState, useRef, useCallback } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Table,
  Button,
  Form,
  Pagination,
  Spinner,
  Alert,
} from "react-bootstrap";
import axios from "axios";
import { Modal } from "react-bootstrap";
import { FaTrash } from "react-icons/fa";
import { BsEye } from "react-icons/bs";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  Legend,
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from "recharts";
import { FaTimes } from "react-icons/fa";
import "./Report.css";
import { URL } from "../../../config";

const COLORS = ["#0088FE", "#00C49F", "#FFBB28", "#FF8042", "#845EC2"];
const DEFAULT_LIMIT = 10;

const Report = () => {
  const [reports, setReports] = useState([]);
  const [selectedReport, setSelectedReport] = useState(null);
  const [showModal, setShowModal] = useState(false);

  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteTarget, setDeleteTarget] = useState(null);
  const [deleting, setDeleting] = useState(false);


  // filters + view
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [orderQuery, setOrderQuery] = useState(""); // NEW: search by order number
  const [viewMode, setViewMode] = useState("table");

  const [isEditingFeedback, setIsEditingFeedback] = useState(false);
  const [feedbackDraft, setFeedbackDraft] = useState("");
  const [savingFeedback, setSavingFeedback] = useState(false);
  const [feedbackEditError, setFeedbackEditError] = useState("");


  const [debouncedOrderQuery, setDebouncedOrderQuery] = useState("");

  // server-side pagination meta
  const [meta, setMeta] = useState({
    page: 1,
    limit: DEFAULT_LIMIT,
    total: 0,
    totalPages: 1,
  });

  // summary + charts from backend
  const [summary, setSummary] = useState({
    grandTotalTransaction: 0,
    grandTotalCommission: 0,
    grandTotalBonus: 0,
    totalResults: 0,
  });
  const [chartData, setChartData] = useState([]);

  const modalRef = useRef();
  const token = localStorage.getItem("adminToken");

  // NEW: Debounce orderQuery by 3 seconds
  useEffect(() => {
    const t = setTimeout(() => {
      setMeta(m => ({ ...m, page: 1 }));
      setDebouncedOrderQuery(orderQuery.trim());
    }, 1500);
    return () => clearTimeout(t);
  }, [orderQuery]);


  const fetchReports = useCallback(
  async (pageOverride) => {
    setLoading(true);
    try {
      const page = pageOverride ?? meta.page;
      const { data } = await axios.get(`${URL}/reports`, {
        headers: token ? { Authorization: `Bearer ${token}` } : undefined,
        params: {
          page,
          limit: meta.limit,
          startDate: startDate || undefined,
          endDate: endDate || undefined,
          // CHANGED: use debounced value, not the raw input
          search: debouncedOrderQuery || undefined,
        },
      });

      setReports(Array.isArray(data?.data) ? data.data : []);
      setMeta((m) => ({
        ...m,
        page: data?.meta?.page || page,
        limit: data?.meta?.limit || m.limit,
        total: data?.meta?.total || 0,
        totalPages: data?.meta?.totalPages || 1,
      }));
      setSummary({
        grandTotalTransaction: Number(data?.summary?.grandTotalTransaction || 0),
        grandTotalCommission: Number(data?.summary?.grandTotalCommission || 0),
        grandTotalBonus: Number(data?.summary?.grandTotalBonus || 0),
        totalResults: Number(data?.summary?.totalResults || 0),
      });
      setChartData(Array.isArray(data?.charts?.byService) ? data.charts.byService : []);
      setError("");
    } catch (err) {
      console.error("Error fetching reports:", err);
      setError("Failed to load reports. Please try again.");
      setReports([]);
      setSummary({
        grandTotalTransaction: 0,
        grandTotalCommission: 0,
        grandTotalBonus: 0,
        totalResults: 0,
      });
      setChartData([]);
    } finally {
      setLoading(false);
    }
  },
  // CHANGED: remove orderQuery, add debouncedOrderQuery
  [token, meta.page, meta.limit, startDate, endDate, debouncedOrderQuery]
);


  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  const handleViewReport = (report) => {
    setSelectedReport(report);
    setIsEditingFeedback(false);
    setFeedbackDraft(report?.feedback || "");
    setFeedbackEditError("");
    setShowModal(true);
    document.body.style.overflow = "hidden";
  };
  const handleCloseModal = () => {
    setShowModal(false);
    setSelectedReport(null);
    setIsEditingFeedback(false);
    setFeedbackDraft("");
    setFeedbackEditError("");
    document.body.style.overflow = "auto";
  };

  // useEffect(() => {
  //   const node = modalRef.current;
  //   const handleBackdropClick = (e) => node && e.target === node && handleCloseModal();
  //   const handleEscapeKey = (e) => e.key === "Escape" && handleCloseModal();
  //   if (node) node.addEventListener("click", handleBackdropClick);
  //   document.addEventListener("keydown", handleEscapeKey);
  //   return () => {
  //     if (node) node.removeEventListener("click", handleBackdropClick);
  //     document.removeEventListener("keydown", handleEscapeKey);
  //   };
  // }, []);

  useEffect(() => {
    if (!showModal) return;

    const node = modalRef.current;

    const handleBackdropClick = (e) => node && e.target === node && handleCloseModal();
    const handleEscapeKey = (e) => e.key === "Escape" && handleCloseModal();

    if (node) node.addEventListener("click", handleBackdropClick);
    document.addEventListener("keydown", handleEscapeKey);

    return () => {
      if (node) node.removeEventListener("click", handleBackdropClick);
      document.removeEventListener("keydown", handleEscapeKey);
    };
  }, [showModal]);

const handleSearch = (e) => {
  e.preventDefault();
  setMeta((m) => ({ ...m, page: 1 }));
  setDebouncedOrderQuery(orderQuery.trim()); // trigger immediate fetch via effect
};


// For feedback
const startEditFeedback = () => {
  setFeedbackDraft(selectedReport?.feedback || "");
  setFeedbackEditError("");
  setIsEditingFeedback(true);
};

const cancelEditFeedback = () => {
  setFeedbackDraft(selectedReport?.feedback || "");
  setFeedbackEditError("");
  setIsEditingFeedback(false);
};

const saveFeedback = async () => {
  try {
    if (!selectedReport) return;

    const txnId = selectedReport?.Id || selectedReport?.id;
    if (!txnId) return;

    setSavingFeedback(true);
    setFeedbackEditError("");

    const { data } = await axios.patch(
      `${URL}/admin/transactions/${txnId}/feedback`,
      { feedback: feedbackDraft }, // can be empty -> backend stores NULL
      { headers: token ? { Authorization: `Bearer ${token}` } : undefined }
    );

    const updatedFeedback = data?.transaction?.feedback ?? null;

    // update modal data
    setSelectedReport((prev) => (prev ? { ...prev, feedback: updatedFeedback } : prev));

    // update row in table cache
    setReports((prev) =>
      prev.map((r) => {
        const rid = r?.Id || r?.id;
        return rid === txnId ? { ...r, feedback: updatedFeedback } : r;
      })
    );

    setIsEditingFeedback(false);
  } catch (err) {
    console.error(err);
    setFeedbackEditError(err?.response?.data?.error || "Failed to update feedback.");
  } finally {
    setSavingFeedback(false);
  }
};



  const handleReset = () => {
  setStartDate("");
  setEndDate("");
  setOrderQuery("");
  setDebouncedOrderQuery(""); // clears backend search immediately
  setMeta((m) => ({ ...m, page: 1 }));
  fetchReports(1);
};

// Delete transactions
const openDeleteModal = (report) => {
  setError("");
  setDeleteTarget(report);
  setShowDeleteModal(true);
};

const closeDeleteModal = () => {
  setShowDeleteModal(false);
  setDeleteTarget(null);
};

const confirmDelete = async () => {
  try {
    const txnId = deleteTarget?.Id || deleteTarget?.id;
    if (!txnId) return;

    setDeleting(true);
    setError("");

    await axios.delete(`${URL}/admin/transactions/${txnId}`, {
      headers: token ? { Authorization: `Bearer ${token}` } : undefined,
    });

    // If page becomes empty after delete, go back one page
    const willBeEmpty = reports.length === 1;
    const nextPage = willBeEmpty && meta.page > 1 ? meta.page - 1 : meta.page;

    closeDeleteModal();
    setMeta((m) => ({ ...m, page: nextPage }));
    fetchReports(nextPage);
  } catch (err) {
    console.error(err);
    setError(err?.response?.data?.error || "Failed to delete transaction.");
  } finally {
    setDeleting(false);
  }
};



  // pagination helpers (UI only)
  const handlePageChange = (pageNumber) => {
    setMeta((m) => ({ ...m, page: pageNumber }));
    fetchReports(pageNumber);
  };

  const getPageItems = (total, current, maxButtons = 7) => {
    const pages = [];
    pages.push(1);
    const siblings = Math.floor((maxButtons - 3) / 2);
    let start = Math.max(2, current - siblings);
    let end = Math.min(total - 1, current + siblings);
    if (current <= siblings + 2) end = Math.min(total - 1, maxButtons - 1);
    if (current >= total - (siblings + 1)) start = Math.max(2, total - (maxButtons - 2));
    if (start > 2) pages.push("start-ellipsis");
    for (let i = start; i <= end; i++) pages.push(i);
    if (end < total - 1) pages.push("end-ellipsis");
    if (total > 1) pages.push(total);
    return pages;
  };

  // Graph data (from backend aggregates)
  const pieData = chartData.map((item) => ({
    name: item.service,
    value: item.revenue,
  }));

  const formatDateTime = (iso) => {
    const d = new Date(iso);
    const dateStr = d.toLocaleDateString("en-US", {
      day: "numeric",
      month: "long",
      year: "numeric",
    });
    const [month, day, year] = dateStr.replace(",", "").split(" ");
    const datePart = `${day}-${month}-${year}`;
    const timeStr = d
      .toLocaleTimeString("en-US", {
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        hour12: true,
      })
      .toLowerCase();
    return `${datePart}, ${timeStr}`;
  };

  const renderReportDetails = () => {
    if (!selectedReport) return null;

    const {
      order_number,
      Service,
      User,
      Servitor,
      totalAmount = 0,
      commissionAmount = 0,
      servitorBonus = 0,
      netAmount, // may be undefined
      transactionDate,
      feedback,
      rating,
      serviceType,
    } = selectedReport;

    const net =
      typeof netAmount === "number"
        ? netAmount
        : Number(totalAmount) - Number(commissionAmount) - Number(servitorBonus || 0);

    return (
      <div className="adminReportdetails-modal">
        <div className="adminReportdetails-modal-header">
          <button className="adminReportdetails-modal-close" onClick={handleCloseModal}>
            <FaTimes size={20} />
          </button>
          <div style={{ display: "flex", alignItems: "center", gap: "16px" }}>
            <div className="adminReportdetails-service-icon">
              <i className="fas fa-tools" style={{ color: "#f59e0b" }} />
            </div>
            <div>
              <h2 className="adminReportdetails-modal-title">
                Details of Order Number #{order_number}
              </h2>
              <p className="adminReportdetails-modal-subtitle">
                {Service?.services_name || serviceType || "N/A"} • Transaction
              </p>
            </div>
          </div>
        </div>

        <div className="adminReportdetails-modal-body">
          {/* Summary Cards */}
          <div className="adminReportdetails-summary-cards">
            <div className="adminReportdetails-summary-card adminReportdetails-amount-card">
              <div>
                <p className="adminReportdetails-detail-text">Total Amount</p>
                <p className="adminReportdetails-price-value">৳{Number(totalAmount).toFixed(2)}</p>
              </div>
            </div>
            <div className="adminReportdetails-summary-card adminReportdetails-commission-card">
              <div>
                <p className="adminReportdetails-detail-text">Commission</p>
                <p className="adminReportdetails-price-value">৳{Number(commissionAmount).toFixed(2)}</p>
              </div>
            </div>
            <div className="adminReportdetails-summary-card adminReportdetails-net-amount-card">
              <div>
                <p className="adminReportdetails-detail-text">Net Amount</p>
                <p className="adminReportdetails-price-value">৳{Number(net).toFixed(2)}</p>
              </div>
            </div>
            <div className="adminReportdetails-summary-card adminReportdetails-date-card">
              <div>
                <p className="adminReportdetails-detail-text">Date & Time</p>
                <p className="adminReportdetails-detail-value">{formatDateTime(transactionDate)}</p>
              </div>
            </div>
          </div>

          {/* User Details */}
          <div className="adminReportdetails-detail-card">
            <h3 className="adminReportdetails-detail-title">
              <i className="fas fa-user" style={{ marginRight: "8px", color: "#f59e0b" }} />
              User Details
            </h3>
            <div className="adminReportdetails-detail-grid">
              <div>
                <p className="adminReportdetails-detail-text">Name</p>
                <p className="adminReportdetails-detail-value">
                  {User ? `${User.FirstName} ${User.LastName}` : "N/A"}
                </p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">User Id</p>
                <p className="adminReportdetails-detail-value">{User?.Id || "N/A"}</p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Mobile</p>
                <p className="adminReportdetails-detail-value">{User?.mobile || "N/A"}</p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Address</p>
                <p className="adminReportdetails-detail-value">{User?.Address || "N/A"}</p>
              </div>
            </div>
          </div>

          {/* Servitor Details */}
          <div className="adminReportdetails-detail-card">
            <h3 className="adminReportdetails-detail-title">
              <i className="fas fa-user-tie" style={{ marginRight: "8px", color: "#f59e0b" }} />
              Servitor Details
            </h3>
            <div className="adminReportdetails-detail-grid">
              <div>
                <p className="adminReportdetails-detail-text">Name</p>
                <p className="adminReportdetails-detail-value">
                  {Servitor ? `${Servitor.FirstName} ${Servitor.LastName}` : "N/A"}
                </p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Servitor Id</p>
                <p className="adminReportdetails-detail-value">{Servitor?.Id || "N/A"}</p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Mobile</p>
                <p className="adminReportdetails-detail-value">{Servitor?.mobile || "N/A"}</p>
              </div>
              <div>
                <p className="adminReportdetails-detail-text">Service</p>
                <p className="adminReportdetails-detail-value">
                  {Service?.services_name || serviceType || "N/A"}
                </p>
              </div>
            </div>
          </div>

          {/* Ratings and Feedback */}
          <div className="adminReportdetails-detail-card">
            <h3 className="adminReportdetails-detail-title">
              <i className="fas fa-comment" style={{ marginRight: "8px", color: "#f59e0b" }} />
              Ratings & Feedback
            </h3>
            <div className="adminReportdetails-feedback-list">
              <div>
                <p className="adminReportdetails-detail-text">Rating</p>
                <p className="adminReportdetails-rating-value">
                  {typeof rating === "number" ? rating.toFixed(1) : "N/A"} / 5
                </p>
                <div className="adminReportdetails-star-container">
                  {[...Array(5)].map((_, index) => (
                    <i
                      key={index}
                      className="fas fa-star"
                      style={{
                        color: index < Math.round(Number(rating || 0)) ? "#f59e0b" : "#e5e7eb",
                      }}
                    />
                  ))}
                </div>
              </div>
              <hr className="adminReportdetails-rating-underline" />
              {/* <div>
                <p className="adminReportdetails-detail-text">Feedback</p>
                {feedback ? (
                  <div className="adminReportdetails-feedback-item">
                    <p className="adminReportdetails-feedback-comment">{feedback}</p>
                    <p className="adminReportdetails-feedback-date">{formatDateTime(transactionDate)}</p>
                  </div>
                ) : (
                  <p className="adminReportdetails-detail-value">No feedback available.</p>
                )}
              </div> */}

              <div>
                <p className="adminReportdetails-detail-text">Feedback</p>

                {isEditingFeedback ? (
                  <>
                    <Form.Control
                      as="textarea"
                      rows={4}
                      value={feedbackDraft}
                      onChange={(e) => setFeedbackDraft(e.target.value)}
                      placeholder="Write feedback..."
                    />

                    {feedbackEditError && (
                      <div className="text-danger small mt-2">{feedbackEditError}</div>
                    )}

                    <div className="mt-2 d-flex gap-2">
                      <Button
                        size="sm"
                        variant="primary"
                        onClick={saveFeedback}
                        disabled={savingFeedback}
                      >
                        {savingFeedback ? "Saving..." : "Save"}
                      </Button>

                      <Button
                        size="sm"
                        variant="secondary"
                        onClick={cancelEditFeedback}
                        disabled={savingFeedback}
                      >
                        Cancel
                      </Button>
                    </div>

                    <div className="text-muted small mt-2">
                      Tip: Leave empty and save to remove the feedback from public testimonials.
                    </div>
                  </>
                ) : (
                  <>
                    {feedback ? (
                      <div className="adminReportdetails-feedback-item">
                        <p className="adminReportdetails-feedback-comment">{feedback}</p>
                        <p className="adminReportdetails-feedback-date">
                          {formatDateTime(transactionDate)}
                        </p>
                      </div>
                    ) : (
                      <p className="adminReportdetails-detail-value">No feedback available.</p>
                    )}

                    <Button
                      size="sm"
                      variant="outline-primary"
                      className="mt-2"
                      onClick={startEditFeedback}
                    >
                      Edit Feedback
                    </Button>
                  </>
                )}
              </div>

            </div>
          </div>
        </div>

        <div className="adminReportdetails-modal-footer">
          <div className="adminReportdetails-footer-buttons">
            <button
              className="adminReportdetails-footer-btn adminReportdetails-footer-btn-close"
              onClick={handleCloseModal}
            >
              <FaTimes /> Close
            </button>
          </div>
        </div>
      </div>
    );
  };

  return (
    <Container fluid className="adminReportdetails-container">
      <Card className="adminReportdetails-card">
        <Card.Header className="adminReportdetails-header">
          <h4 className="adminReportdetails-title">Transaction Details</h4>
        </Card.Header>
        <Card.Body>
          {/* Stats Cards */}
          <div className="adminReportdetails-stats-container">
            <div className="adminReportdetails-stats-card adminReportdetails-blue">
              <div className="adminReportdetails-stats-icon">
                <i className="fas fa-money-bill-wave"></i>
              </div>
              <div className="adminReportdetails-stats-title">TOTAL TRANSACTION AMOUNT</div>
              <div className="adminReportdetails-stats-value">
                {summary.grandTotalTransaction.toFixed(2)}৳
              </div>
            </div>

            <div className="adminReportdetails-stats-card adminReportdetails-green">
              <div className="adminReportdetails-stats-icon">
                <i className="fas fa-coins"></i>
              </div>
              <div className="adminReportdetails-stats-title">TOTAL COMMISSION</div>
              <div className="adminReportdetails-stats-value">
                {summary.grandTotalCommission.toFixed(2)}৳
              </div>
            </div>

            <div className="adminReportdetails-stats-card adminReportdetails-orange">
              <div className="adminReportdetails-stats-icon">
                <i className="fas fa-gift"></i>
              </div>
              <div className="adminReportdetails-stats-title">TOTAL SERVITOR BONUS</div>
              <div className="adminReportdetails-stats-value">
                {summary.grandTotalBonus.toFixed(2)}৳
              </div>
            </div>

            <div className="adminReportdetails-stats-card adminReportdetails-purple">
              <div className="adminReportdetails-stats-icon">
                <i className="fas fa-chart-bar"></i>
              </div>
              <div className="adminReportdetails-stats-title">TRANSACTION COUNT</div>
              <div className="adminReportdetails-stats-value">{summary.totalResults}</div>
            </div>
          </div>

          {/* Filters form – Start/End date + Order Number + Buttons (keeps overall look) */}
          <Form onSubmit={handleSearch} className="mb-4">
            <Row className="align-items-end">
              <Col md={3} className="mb-3">
                <Form.Group controlId="startDate">
                  <Form.Label>Start Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => setStartDate(e.target.value)}
                    className="adminReportdetails-search"
                  />
                </Form.Group>
              </Col>
              <Col md={3} className="mb-3">
                <Form.Group controlId="endDate">
                  <Form.Label>End Date</Form.Label>
                  <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => setEndDate(e.target.value)}
                    className="adminReportdetails-search"
                  />
                </Form.Group>
              </Col>

              {/* NEW: Order Number search */}
              <Col md={3} className="mb-3">
                <Form.Group controlId="orderNumber">
                  <Form.Label>Order Number</Form.Label>
                  <Form.Control
                    type="text"
                    placeholder="Enter order number"
                    value={orderQuery}
                    onChange={(e) => setOrderQuery(e.target.value)}
                    className="adminReportdetails-search"
                  />
                </Form.Group>
              </Col>

              <Col md={3} className="mb-3 d-flex">
                <div className="ms-auto">
                  <Button variant="primary" type="submit" className="me-2 adminReportdetails-filter-btn">
                    Search
                  </Button>
                  <Button
                    variant="outline-primary"
                    onClick={handleReset}
                    className="adminReportdetails-filter-btn"
                  >
                    Reset
                  </Button>
                </div>
              </Col>
            </Row>
          </Form>

          {/* View Toggle */}
          <div className="adminReportdetails-filter-container">
            <div className="adminReportdetails-service-filters">
              <Button
                variant={viewMode === "table" ? "primary" : "outline-primary"}
                className="adminReportdetails-filter-btn"
                onClick={() => setViewMode("table")}
              >
                Table View
              </Button>
              <Button
                variant={viewMode === "graph" ? "primary" : "outline-primary"}
                className="adminReportdetails-filter-btn"
                onClick={() => setViewMode("graph")}
              >
                Graph View
              </Button>
            </div>
          </div>

          {loading && (
            <div className="text-center">
              <Spinner animation="border" />
            </div>
          )}

          {error && (
            <Alert variant="danger" className="adminReportdetails-error">
              {error}
            </Alert>
          )}

          {!loading && !error && summary.totalResults === 0 && (
            <p className="adminReportdetails-empty-text">No transactions found.</p>
          )}

          {!loading && !error && summary.totalResults > 0 && (
            <>
              {viewMode === "table" ? (
                <>
                  <Table striped bordered hover responsive className="adminReportdetails-table">
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>Order Number</th>
                        <th>Service Name</th>
                        {/* <th>User Name</th>
                        <th>Servitor Name</th> */}
                        <th>Total Amount</th>
                        <th>Commission</th>
                        <th>Servitor Bonus</th>
                        <th>Transaction Date</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {reports.map((report, index) => (
                        <tr key={report.Id || report.id || `${report.order_number}-${index}`}>
                          <td>{index + 1 + (meta.page - 1) * meta.limit}</td>
                          <td>{report.order_number}</td>
                          <td>{report?.Service?.services_name || report?.serviceType || "N/A"}</td>
                          {/* <td>
                            {report.User
                              ? `${report.User.FirstName} ${report.User.LastName}`
                              : "N/A"}
                          </td>
                          <td>
                            {report.Servitor
                              ? `${report.Servitor.FirstName} ${report.Servitor.LastName}`
                              : "N/A"}
                          </td> */}
                          <td>{Number(report.totalAmount || 0).toFixed(2)}৳</td>
                          <td>{Number(report.commissionAmount || 0).toFixed(2)}৳</td>
                          <td>
                            {report.servitorBonus && Number(report.servitorBonus) > 0
                              ? `৳${Number(report.servitorBonus).toFixed(2)}`
                              : "-"}
                          </td>
                          <td>{formatDateTime(report.transactionDate)}</td>
                          <td>
                            <Button
                              variant="outline-primary"
                              size="sm"
                              className="adminReportdetails-action-btn"
                              onClick={() => handleViewReport(report)}
                            >
                              <BsEye size={16} />
                            </Button>

                            <Button
                              variant="outline-danger"
                              size="sm"
                              className="adminReportdetails-action-btn"
                              onClick={() => openDeleteModal(report)}
                              title="Delete"
                            >
                              <FaTrash size={14} />
                            </Button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>

                  {/* Server-side pagination controls */}
                  <Pagination>
                    <Pagination.First onClick={() => handlePageChange(1)} disabled={meta.page === 1} />
                    <Pagination.Prev
                      onClick={() => handlePageChange(meta.page - 1)}
                      disabled={meta.page === 1}
                    />
                    {getPageItems(meta.totalPages, meta.page).map((item, idx) =>
                      item === "start-ellipsis" || item === "end-ellipsis" ? (
                        <Pagination.Ellipsis key={item + idx} disabled />
                      ) : (
                        <Pagination.Item
                          key={item}
                          active={item === meta.page}
                          onClick={() => handlePageChange(item)}
                        >
                          {item}
                        </Pagination.Item>
                      )
                    )}
                    <Pagination.Next
                      onClick={() => handlePageChange(meta.page + 1)}
                      disabled={meta.page === meta.totalPages}
                    />
                    <Pagination.Last
                      onClick={() => handlePageChange(meta.totalPages)}
                      disabled={meta.page === meta.totalPages}
                    />
                  </Pagination>
                  <div className="mt-2 text-muted adminReportdetails-results-text">
                    Showing {(meta.page - 1) * meta.limit + 1} to{" "}
                    {Math.min(meta.page * meta.limit, summary.totalResults)} of {summary.totalResults} results
                  </div>
                </>
              ) : (
                <Row>
                  <Col md={6} className="mb-4">
                    <Card className="adminReportdetails-chart-card">
                      <Card.Body>
                        <h5 className="adminReportdetails-chart-title">Revenue by Service Type</h5>
                        <div style={{ width: "100%", height: 300 }}>
                          <ResponsiveContainer>
                            <BarChart data={chartData}>
                              <XAxis dataKey="service" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Bar dataKey="revenue" fill="#8884d8" name="Revenue" />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6} className="mb-4">
                    <Card className="adminReportdetails-chart-card">
                      <Card.Body>
                        <h5 className="adminReportdetails-chart-title">Commission by Service Type</h5>
                        <div style={{ width: "100%", height: 300 }}>
                          <ResponsiveContainer>
                            <BarChart data={chartData}>
                              <XAxis dataKey="service" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Bar dataKey="commission" fill="#ffc658" name="Commission" />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6} className="mb-4">
                    <Card className="adminReportdetails-chart-card">
                      <Card.Body>
                        <h5 className="adminReportdetails-chart-title">Transaction Count by Service Type</h5>
                        <div style={{ width: "100%", height: 300 }}>
                          <ResponsiveContainer>
                            <BarChart data={chartData}>
                              <XAxis dataKey="service" />
                              <YAxis />
                              <Tooltip />
                              <Legend />
                              <Bar dataKey="count" fill="#82ca9d" name="Transaction Count" />
                            </BarChart>
                          </ResponsiveContainer>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                  <Col md={6}>
                    <Card className="adminReportdetails-chart-card">
                      <Card.Body>
                        <h5 className="adminReportdetails-chart-title">Revenue Distribution</h5>
                        <div style={{ width: "100%", height: 300 }}>
                          <ResponsiveContainer>
                            <PieChart>
                              <Pie data={pieData} dataKey="value" nameKey="name" outerRadius={100} label>
                                {pieData.map((entry, index) => (
                                  <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                              </Pie>
                              <Tooltip />
                            </PieChart>
                          </ResponsiveContainer>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              )}
            </>
          )}
        </Card.Body>
      </Card>

      {showModal && (
        <div className="adminReportdetails-modal-backdrop" ref={modalRef}>
          {renderReportDetails()}
        </div>
      )}

      <Modal show={showDeleteModal} onHide={closeDeleteModal} centered>
        <Modal.Header closeButton>
          <Modal.Title>Delete Transaction</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <p>Are you sure you want to delete this transaction?</p>

          <div className="text-muted">
            <div><b>Order:</b> {deleteTarget?.order_number || "N/A"}</div>
            <div><b>Amount:</b> ৳{Number(deleteTarget?.totalAmount || 0).toFixed(2)}</div>
            <div><b>Date:</b> {deleteTarget?.transactionDate ? formatDateTime(deleteTarget.transactionDate) : "N/A"}</div>
          </div>

          <Alert variant="warning" className="mt-3 mb-0">
            This action cannot be undone.
          </Alert>
        </Modal.Body>

        <Modal.Footer>
          <Button variant="secondary" onClick={closeDeleteModal} disabled={deleting}>
            Cancel
          </Button>
          <Button variant="danger" onClick={confirmDelete} disabled={deleting}>
            {deleting ? "Deleting..." : "Yes, Delete"}
          </Button>
        </Modal.Footer>
      </Modal>


    </Container>
  );
};

export default Report;
